export enum ElevatorDetailTabs {
    IOT_DATA = 'iot-data',
    TECHNICAL_DATA = 'technical-data',
    COMPONENTS = 'components',
    DOCUMENTS = 'documents',
}
